var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M17 8.5C17 3.81657 13.1848 0 8.49699 0C3.8092 0 0 3.81657 0 8.5C0 13.1834 3.81522 17 8.49699 17H16.9218L15.2488 13.6409C16.3742 12.1601 16.994 10.3601 16.994 8.49398L17 8.5ZM11.2411 12.5754L8.38266 11.0705L5.52425 12.5754L6.07186 9.38492L3.76106 7.12748L6.95646 6.66395L8.38266 3.76239L9.80885 6.66395L13.0042 7.12748L10.6935 9.38492L11.2411 12.5754Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatStar);
export default __webpack_public_path__ + "static/media/chat-star.4e3df58432890824fdc0a03a3b9e8e3d.svg";
export { ForwardRef as ReactComponent };